import * as React from 'react';
export const MOSvg = React.forwardRef(function MOSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#159570',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M7.403 7.153A1.748 1.748 0 0 1 8 5a1.748 1.748 0 0 1 .623 2.093 1.748 1.748 0 0 1 2 .657 1.748 1.748 0 0 1-2.687.225A1.748 1.748 0 0 1 5.25 7.75a1.748 1.748 0 0 1 2.153-.597Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M5 5.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1-1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM7.5 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1.5.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z',
      }),
    ),
  );
});
MOSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MO = {
  category: 'flag',
  colorable: false,
  name: 'MO',
  svg: MOSvg,
};
